const procedimientos = [
  {
    slug: "alta-colaborador-procedimiento",
    titulo: "Solicitud de Alta de Colaborador",
    pdf: "alta-nuevo-colaborador-proceso.pdf",
  },
  {
    slug: "baja-colaborador-procedimiento",
    titulo: "Solicitud de Baja de Colaborador",
    pdf: "baja-colaborador-proceso.pdf",
  },
  {
    slug: "solicitud-camioneta",
    titulo: "Solicitud Camioneta",
    pdf: "solicitud-camioneta.pdf",
  },
  {
    slug: "incidencias-rh",
    titulo: "Incidencias RH",
    pdf: "Incidencias-RH.pdf",
  },
];

export default procedimientos;
